import {HookClass, Hook, BaseHook, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, of} from 'rxjs';
import {concatMap, map, toArray} from 'rxjs/operators';

@HookClass('number')
export class NumberHook extends BaseHook {

    @Hook('42da9b37-689f-43b5-9847-204466337dbc')
    public increment(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return from(Object.keys(inputArtifact.object.data))
            .pipe(map((key: string) => {
                ++inputArtifact.object.data[key];
            }), toArray())
            .pipe(concatMap(() => {
                return of(inputArtifact);
            }));
    }


    @Hook('620bcaaf-2af0-4bf8-ac80-5a8ab7dcc436')
    public toFloat(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return from(Object.keys(inputArtifact.object.data))
            .pipe(map((key: string) => {
                inputArtifact.object.data[key] = parseFloat(inputArtifact.object.data[key]).toFixed(inputArtifact.object.config.fractionDigits);
            }), toArray())
            .pipe(concatMap(() => {
                return of(inputArtifact);
            }));
    }

}
